/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eventTitle: NonNullable<unknown> }} Areyousureyouwanttodeleteevent7Inputs */

const en_areyousureyouwanttodeleteevent7 = /** @type {(inputs: Areyousureyouwanttodeleteevent7Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete "${i?.eventTitle}"?`)
};

const de_areyousureyouwanttodeleteevent7 = /** @type {(inputs: Areyousureyouwanttodeleteevent7Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Willst du „${i?.eventTitle}“ wirklich löschen?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete \"{eventTitle}\"?" |
*
* @param {Areyousureyouwanttodeleteevent7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const areyousureyouwanttodeleteevent7 = /** @type {((inputs: Areyousureyouwanttodeleteevent7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Areyousureyouwanttodeleteevent7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_areyousureyouwanttodeleteevent7(inputs)
	return de_areyousureyouwanttodeleteevent7(inputs)
});
export { areyousureyouwanttodeleteevent7 as "areYouSureYouWantToDeleteEvent" }